module.exports = __webpack_public_path__ + "static/media/ei04.e699d4dd.png";